export default "__VITE_ASSET__BWhQw3KQ__"